import Vue from 'vue';
import Component from 'vue-class-component';
import * as api from 'core/api';
import * as auth from 'core/auth';
import router from 'src/router';
import * as i18next from 'i18next';
import AccountBonusesComponent from './bonuses';
import AccountContactsComponent from './contacts';
import AccountCouponsComponent from './coupons';
import AccountOrdersComponent from './orders';
import AccountCorporateComponent from './corporate';
import AccountProfileComponent from './profile';
import AccountSecurityComponent from './security';
import AccountSettingsComponent from './settings';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component({
    components: {
        'account-bonuses': AccountBonusesComponent,
        'account-contacts': AccountContactsComponent,
        'account-coupons': AccountCouponsComponent,
        'account-orders': AccountOrdersComponent,
        'account-corporate': AccountCorporateComponent,
        'account-profile': AccountProfileComponent,
        'account-security': AccountSecurityComponent,
        'account-settings': AccountSettingsComponent
    }
})
export default class AccountViewComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    currentUser: api.UserAccount | null = null;

    view: string = 'loading';

    mounted() {
        if (this.$auth.authenticated) {
            this.loadModel();
        } else {
            this.$nextTick(function() {
                if (this.$route.query.token) {
                    // If token in url the try to confirm user
                    this.$auth.confirm(this.$route.query.token as string).then(
                        (result: api.User) => {
                            if (result.hasPassword) {
                                window.location.href = '/account';
                            }
                            else {
                                router.push('/account/welcome');
                            }
                        },
                        () => {
                            window.location.href = '/account';
                        }
                    );
                } else {
                    (<any>this.$root.$refs).signInPanel.onSignIn();
                }
            });
        }
    }

    loadModel() {
        this.view = 'loading';

        this.$auth.getCurrentUserAccount().then(
            (result: api.UserAccount) => {                
                if (result.hasPassword) {
                    this.currentUser = result;

                    this.view = 'view';
                }
                else {
                    router.push('/account/welcome');
                }
            },
            () => {
                (<any>this.$root.$refs).signInPanel.$refs.modalSignIn.show();
            }
        );
    }

    onSignOut() {
        this.$auth.signOut().then(
            (response: boolean) => {
                (<any>this).$ga.sendEvent('signout', 'success', 'signout.success');

                location.href = '/';
            },
            (error) => {
                (this.$root as any).$refs.dialogMessage.show({
                    title: i18next.t('error'),
                    text: (error.response.data && error.response.data.message) ? error.response.data.message : i18next.t('error_server_tryagain')
                });

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );        
    }
}
